module.exports = __webpack_public_path__ + "media/images/application/template/logos/rospa-member-logo-49cf96d7c5891440a3473511aea90357.png";